import { useQuery } from '@tanstack/react-query'

import api, { withAuthenticatedRequest } from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchClientByCnpjCpf(cnpjcpf?: string) {
  const token = useAccessToken()
  return useQuery({
    queryKey: ['client', cnpjcpf],
    queryFn: async () => {
      if (!cnpjcpf) throw new Error('CNPJ ou CPF não fornecido')

      const response = await api.get(`/clients/${cnpjcpf}`, {
        ...withAuthenticatedRequest(token)
      })

      if (response.data && response.data.data) {
        return response.data.data
      } else {
        throw new Error('Data não encontrado no resultado')
      }
    },
    enabled: Boolean(cnpjcpf)
  })
}
